import React from "react";
import { MDBRow, MDBCol, MDBIcon } from "mdbreact";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setCategory } from "../features/categories/categorySlice";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMoneyBills,
  faScrewdriverWrench,
  faTruck,
} from "@fortawesome/free-solid-svg-icons";
import { faBoxesPacking } from "@fortawesome/free-solid-svg-icons/faBoxesPacking";
const AdminHome = (props) => {
  const sCategory = useSelector((state) => state.category.value);
  const dispatch = useDispatch();
  let history = useHistory();

  const NavigatePage = (x) => {
    dispatch(setCategory(x));
    if (x === "3") {
      history.push(props.deployURL + "/services");
    } else if (x === "4") {
      history.push(props.deployURL + "/itemsoutsourced");
    } else if (x === "5") {
      history.push(props.deployURL + "/servicesoutsourced");
    } else {
      history.push(props.deployURL + "/items");
    }
  };

  return (
    <section className="text-center">
      <p
        style={{ fontFamily: "Montserrat", fontWeight: "400" }}
        className="h2-responsive font-weight-bold mb-0 pb-0 pt-5"
      >
        Administrator
      </p>

      <MDBRow>
        <MDBCol md="3">
          <Link to="#" onClick={() => NavigatePage("2")}>
            <MDBIcon icon="barcode" size="8x" className="black-text" />
            <h6 className="font-weight-bold my-4">Inventory Items</h6>
            <p className="grey-text small mb-md-0 mb-5">Add/Edit Items.</p>
          </Link>
        </MDBCol>
        <MDBCol md="3">
          <Link to="#" onClick={() => NavigatePage("3")}>
            {/* <MDBIcon icon="user-tie" size="8x" className="cyan-text" />
             */}
            <FontAwesomeIcon
              icon={faScrewdriverWrench}
              size="8x"
              className="cyan-text"
            />
            <h6 className="font-weight-bold my-4">Services</h6>
            <p className="grey-text small mb-md-0 mb-5">Add/Edit Services.</p>
          </Link>
        </MDBCol>
        <MDBCol md="3">
          <Link to="#" onClick={() => NavigatePage("4")}>
            <MDBIcon icon="barcode" size="8x" className="red-text" />
            <h6 className="font-weight-bold my-4">Outsourced Items</h6>
            <p className="grey-text small mb-md-0 mb-5">
              Add/Edit Outsourced Items.
            </p>
          </Link>
        </MDBCol>
        <MDBCol md="3">
          <Link to="#" onClick={() => NavigatePage("5")}>
            {/* <MDBIcon icon="user-tie" size="8x" className="cyan-text" />
             */}
            <FontAwesomeIcon
              icon={faScrewdriverWrench}
              size="8x"
              className="purple-text"
            />
            <h6 className="font-weight-bold my-4">Outsourced Services</h6>
            <p className="grey-text small mb-md-0 mb-5">
              Add/Edit Outsourced Services.
            </p>
          </Link>
        </MDBCol>
      </MDBRow>

      <MDBRow className="pt-5">
        <MDBCol md="3">
          <Link to={props.deployURL + "/packages"}>
            <FontAwesomeIcon
              icon={faBoxesPacking}
              size="8x"
              className="indigo-text"
            />
            <h6 className="font-weight-bold my-4">Packages</h6>
            <p className="grey-text small mb-md-0 mb-5">
              Add/Edit Package of Items/Services
            </p>
          </Link>
        </MDBCol>
        <MDBCol md="3">
          <Link to={props.deployURL + "/receiving"}>
            {/* <MDBIcon
              fas
              icon="cart-arrow-down"
              size="8x"
              className="green-text"
            /> */}
            <FontAwesomeIcon icon={faTruck} size="8x" className="green-text" />
            <h6 className="font-weight-bold my-4">Receiving</h6>
            <p className="grey-text small mb-md-0 mb-5">
              Encode purchased goods/items.
            </p>
          </Link>
        </MDBCol>
        <MDBCol md="3">
          <Link to={props.deployURL + "/inventory"}>
            <MDBIcon fas icon="tasks" size="8x" className="indigo-text" />
            <h6 className="font-weight-bold my-4">Inventory Posting</h6>
            <p className="grey-text small mb-md-0 mb-5">
              Generate inventory for a specific period.
            </p>
          </Link>
        </MDBCol>
        <MDBCol md="3">
          <Link to={props.deployURL + "/expenses"}>
            <MDBIcon icon="money-bill" size="8x" className="brown-text" />
            <h6 className="font-weight-bold my-4">Expense Management</h6>
            <p className="grey-text small mb-md-0 mb-5">
              Record operation expenses.
            </p>
          </Link>
        </MDBCol>
      </MDBRow>

      <MDBRow className="pt-5">
        <MDBCol md="3">
          <Link to={props.deployURL + "/suppliers"}>
            <MDBIcon icon="handshake" size="8x" className="orange-text" />
            <h6 className="font-weight-bold my-4">Supplier Management</h6>
            <p className="grey-text small mb-md-0 mb-5">Add/Edit Suppliers.</p>
          </Link>
        </MDBCol>
        <MDBCol md="3">
          <Link to={props.deployURL + "/usersmanagement"}>
            <MDBIcon icon="users" size="8x" className="blue-text" />
            <h6 className="font-weight-bold my-4">User Management</h6>
            <p className="grey-text small mb-md-0 mb-5">
              Assign User Access Levels.
            </p>
          </Link>
        </MDBCol>
        <MDBCol md="3">
          <Link to={props.deployURL + "/expensestool"}>
            {/* <MDBIcon icon="coins" size="8x" className="purple-text" /> */}
            <FontAwesomeIcon
              icon={faMoneyBills}
              size="8x"
              className="purple-text"
            />
            <h6 className="font-weight-bold my-4">Expense Library</h6>
            <p className="grey-text small mb-md-0 mb-5">
              Add / Edit Expenses List.
            </p>
          </Link>
        </MDBCol>

        <MDBCol md="3">
          <Link to={props.deployURL + "/salesadmin"}>
            <MDBIcon icon="trash-alt" size="8x" className="red-text" />
            <h6 className="font-weight-bold my-4">Delete Invoices</h6>
            <p className="grey-text small mb-md-0 mb-5">
              Delete or activate invoices.
            </p>
          </Link>
        </MDBCol>
      </MDBRow>
      <MDBRow className="pt-5">
        <MDBCol md="3">
          <Link to={props.deployURL + "/reports"}>
            <MDBIcon far icon="chart-bar" size="8x" className="cyan-text" />
            <h6 className="font-weight-bold my-4">Reports</h6>
            <p className="grey-text small mb-md-0 mb-5">Generate reports.</p>
          </Link>
        </MDBCol>
      </MDBRow>
    </section>
  );
};

export default AdminHome;
